import axios from 'axios';
import JSZip from 'jszip';
import FileSaver from 'file-saver';
import FilesApi from '@/services/filesToDownload';

let path = '';

const getFile = url => new Promise((resolve, reject) => {
  axios({
    method: 'get',
    url,
    headers: {
      credentials: 'include',
      crossdomain: true,
    },
    responseType: 'blob',
  })
    .then((data) => {
      resolve(data.data);
    })
    .catch((error) => {
      reject(error.toString());
    });
});

const getOnlyFiles = async (idtParent, fileName) => {
  // Vai conter todos os arquivos
  const files = [];
  path += `${fileName}/`;
  const filesAndFolder = await FilesApi.getFilesByIdtParent(idtParent);
  files.push(...filesAndFolder.files);
  // eslint-disable-next-line no-param-reassign
  // eslint-disable-next-line array-callback-return
  files.map((file) => {
    // eslint-disable-next-line no-param-reassign
    file.path = path;
  });
  if (filesAndFolder.folders.length > 0) {
    // eslint-disable-next-line no-restricted-syntax
    for (const folder of filesAndFolder.folders) {
      // eslint-disable-next-line no-await-in-loop
      await getOnlyFiles(folder.idt, folder.file_name).then((result) => {
        files.push(...result);
      });
    }
  }
  return files;
};


const zipFiles = async (file) => {
  const zip = new JSZip();
  const cache = {};
  const promises = [];
  let files = [];
  let fileName = '';
  // Pega somente os arquivos de todos os descendentes
  if (file.file_type === 'folder') {
    fileName = file.file_name;
    files = await getOnlyFiles(file.idt, file.file_name);
  } else {
    fileName = file.file_name.replace(/\.[^/.]+$/, '');
    files.push(file);
  }

  // Para cada arquivo
  files.forEach((item) => {
    const promise = getFile(item.signURL).then((data) => {
      const pathFileName = item.path !== undefined ? item.path + item.file_name : item.file_name;
      zip.file(`${pathFileName}`, data, { binary: true }); // adiciona os arquivos um por um
      cache[item.file_name] = data;
    });
    promises.push(promise);
  });
  Promise.all(promises).then(() => {
    zip.generateAsync({ type: 'blob' }).then((content) => {
      // Gerando um binary stream
      FileSaver.saveAs(content, `${fileName}.zip`); // Salvando o arquivo com file-saver Custom file name
    });
  });
  path = '';
};

export default zipFiles;
